var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimePastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_633_3396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C7.53822 0.507447 5.16524 1.42045 3.33333 3.065V0.5H1.66667V4.78583C1.66711 5.19612 1.83029 5.58948 2.12041 5.87959C2.41052 6.16971 2.80388 6.33289 3.21417 6.33333H7.5V4.66667H4.06583C5.42022 3.29464 7.20901 2.4355 9.12656 2.23602C11.0441 2.03655 12.9714 2.50913 14.5792 3.57301C16.187 4.6369 17.3755 6.22606 17.9415 8.06898C18.5076 9.91191 18.4162 11.8942 17.6829 13.6772C16.9496 15.4602 15.6199 16.9332 13.921 17.8446C12.2221 18.756 10.2595 19.0491 8.3684 18.674C6.47735 18.2989 4.77524 17.2787 3.5529 15.7878C2.33056 14.297 1.66384 12.4279 1.66667 10.5H0C0 12.4778 0.58649 14.4112 1.6853 16.0557C2.78412 17.7002 4.3459 18.9819 6.17317 19.7388C8.00043 20.4957 10.0111 20.6937 11.9509 20.3079C13.8907 19.922 15.6725 18.9696 17.0711 17.5711C18.4696 16.1725 19.422 14.3907 19.8079 12.4509C20.1937 10.5111 19.9957 8.50043 19.2388 6.67317C18.4819 4.8459 17.2002 3.28412 15.5557 2.1853C13.9112 1.08649 11.9778 0.5 10 0.5V0.5Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 6.33203V10.8437L11.9112 13.5879L13.0895 12.4095L10.8337 10.1537V6.33203H9.16699Z",
    fill: "#656565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_633_3396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimePastIcon);
export default __webpack_public_path__ + "static/media/time-past-icon.320a98731c38098fd312aabe0939b3c3.svg";
export { ForwardRef as ReactComponent };